import { OPENEMR_ENDPOINTS, ORCHESTRATOR_ENDPOINTS } from "common/endpoints";
import { request } from "common/services/request";

export const getUserConversations = (userId: string, patientId: string) => {
    return request('orchestrator').get(ORCHESTRATOR_ENDPOINTS.CONVERSATIONS.BASE, {
        params: {
            user_id: userId,
            patient_id: patientId,
            limit: 50,
            offset: 0,
        },
    })
}

export const getUserPatients = (userId: string) => {
    // OpenEMR credentials live server-side; the orchestrator ignores any
    // client_id/client_secret in the body, so none are sent.
    return request('orchestrator').post(OPENEMR_ENDPOINTS.OPENEMR_PATIENTS, {
        user_id: userId,
    });

}
